import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import connectComponent from "redux/connectComponent";
import * as DB from "helpers/db";
import Projects from "./projects";

const JoinedProjects = (props) => {
  const { actions, authentication } = props;

  const [loaded, setLoaded] = useState(false);

  const userId = authentication.userId;

  const finished = () => setLoaded(true);
  useEffect(() => {
    actions.loadProjectMembershipsForUserId(userId).then(finished);
  }, [authentication.version]);

  return <Projects ids={DB.activeProjectIds(props)} loaded={loaded} />;
};

JoinedProjects.propTypes = {
  actions: PropTypes.object,
  authentication: PropTypes.object
};

export default connectComponent(JoinedProjects, [
  "authentication",
  "projects",
  "project_memberships"
]);
